//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets Enabled field from settings for a subtenant.
 */
export function getIsSendingEnabled(subtenantId: number, config?: AxiosRequestConfig | undefined): Promise<boolean> {
    let url_ = getBaseUrl() + "/api/mail/settings/documents/{subtenantId}/enabled";
    if (subtenantId === undefined || subtenantId === null)
      throw new Error("The parameter 'subtenantId' must be defined.");
    url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetIsSendingEnabled,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetIsSendingEnabled?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetIsSendingEnabled(_response);
    });
}

function processGetIsSendingEnabled(response: AxiosResponse): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<boolean>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<boolean>(null as any);
}

/**
 * Gets document settings for a subtenant.
 */
export function getDocumentMailSettings(subtenantId: number, config?: AxiosRequestConfig | undefined): Promise<Types.DocumentMailSettingsDto> {
    let url_ = getBaseUrl() + "/api/mail/settings/documents/{subtenantId}";
    if (subtenantId === undefined || subtenantId === null)
      throw new Error("The parameter 'subtenantId' must be defined.");
    url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetDocumentMailSettings,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetDocumentMailSettings?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetDocumentMailSettings(_response);
    });
}

function processGetDocumentMailSettings(response: AxiosResponse): Promise<Types.DocumentMailSettingsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initDocumentMailSettingsDto(resultData200);
        return Promise.resolve<Types.DocumentMailSettingsDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DocumentMailSettingsDto>(null as any);
}

/**
 * Patches document settings for a subtenant.
 */
export function patchDocumentMailSettings(subtenantId: number, dto: Types.DocumentMailSettingsPatchDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/mail/settings/documents/{subtenantId}";
    if (subtenantId === undefined || subtenantId === null)
      throw new Error("The parameter 'subtenantId' must be defined.");
    url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeDocumentMailSettingsPatchDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchDocumentMailSettings,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigPatchDocumentMailSettings?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchDocumentMailSettings(_response);
    });
}

function processPatchDocumentMailSettings(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetIsSendingEnabled: Partial<AxiosRequestConfig> | null;
export function getGetIsSendingEnabledRequestConfig() {
  return _requestConfigGetIsSendingEnabled;
}
export function setGetIsSendingEnabledRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetIsSendingEnabled = value;
}
export function patchGetIsSendingEnabledRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetIsSendingEnabled = patch(_requestConfigGetIsSendingEnabled ?? {});
}

let _requestConfigGetDocumentMailSettings: Partial<AxiosRequestConfig> | null;
export function getGetDocumentMailSettingsRequestConfig() {
  return _requestConfigGetDocumentMailSettings;
}
export function setGetDocumentMailSettingsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetDocumentMailSettings = value;
}
export function patchGetDocumentMailSettingsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetDocumentMailSettings = patch(_requestConfigGetDocumentMailSettings ?? {});
}

let _requestConfigPatchDocumentMailSettings: Partial<AxiosRequestConfig> | null;
export function getPatchDocumentMailSettingsRequestConfig() {
  return _requestConfigPatchDocumentMailSettings;
}
export function setPatchDocumentMailSettingsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchDocumentMailSettings = value;
}
export function patchPatchDocumentMailSettingsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchDocumentMailSettings = patch(_requestConfigPatchDocumentMailSettings ?? {});
}